export default __webpack_public_path__ + "static/media/elf-premint.31d08feb.png";